module.exports = __webpack_public_path__ + "img/advantage4@2x.44e7e59e.png";